module.exports = __webpack_public_path__ + "img/mastercard.5f39b19e.svg";